module.exports = __webpack_public_path__ + "static/billboardslider-12-min-8cf584a4ca2de1e4efc0ff6996e8a3c4.jpg";